import { PROMO_TYPE_KEY, SUBSCRIPTION_COUPON_KEY } from '../../../constants';
import { RouterModel } from '../../../modules/router/model';
import { V2PromoTypes } from './types';

/**
 * If the URL params contain `promo_type=[xyz]`,
 * this function stores the promo type in session storage.
 *
 * If the params contain `coupon=[xyz]`, it stores the coupon value in session storage.
 */
export const handlePlanPromoParams = (
  currentPath: string,
  searchParams: URLSearchParams,
  router: RouterModel,
  isServer: boolean
) => {
  // Since Project Launchpad, backstage is combined with other promo offers
  // Rewrite the URL to use `promo_type=backstage` rather than `backstage_access=true`
  if (searchParams.has('backstage_access')) {
    searchParams.delete('backstage_access');
    searchParams.append('promo_type', V2PromoTypes.BACKSTAGE);
    return router.replace(`${currentPath}?${searchParams.toString()}`);
  }

  // Enable promos if the URL includes `promo_type={promoName}`
  const promoTypeParam = searchParams.get('promo_type') || null;
  // Enable coupons if the URL includes `coupon={xyz}`
  const couponParam = searchParams.get('coupon') || null;

  if (!isServer) {
    promoTypeParam && window.sessionStorage.setItem(PROMO_TYPE_KEY, promoTypeParam);
    couponParam && window.sessionStorage.setItem(SUBSCRIPTION_COUPON_KEY, couponParam);
  }
};
